/* unplugin-vue-components disabled */import script from "./PropsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropsCard.vue?vue&type=script&setup=true&lang=js"

import "./PropsCard.vue?vue&type=style&index=0&id=1781a400&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1781a400"]])

export default __exports__